/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Trigger: specific classes
		 */
		// none yet

		/**
		 * Photogrid: Animate tiles on scroll
		 * Photogrid: Animate tiles on scroll
		 * Photogrid: Animate tiles on scroll
		 * Photogrid: Animate tiles on scroll
		 */
		var tiles = document.querySelectorAll('.photogrid .tile');

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-visible');
					observer.unobserve(entry.target);
				}
			});
		}, {
			threshold: 0.15,
			rootMargin: '0px 0px -10% 0px'
		});

		tiles.forEach(function (tile) {
			observer.observe(tile);
		});

		/**
		 * Lightbox init
		 * Lightbox init
		 * Lightbox init
		 * Lightbox init
		 */
		setTimeout(function () {
			$('.js-lightbox').simpleLightbox({
				history: false,
				captions: false,
				animationSpeed: 0,
				fadeSpeed: 0,
				nav: true,
				close: true
			});
		}, 500);

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init);

